module.exports = __webpack_public_path__ + "static/media/deeplex.1a71cc38.pdf";